<ng-container #container></ng-container>
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <h5>Energie electrica</h5>
            </div>
            <div class="col-xl-3 col-md-3" [formGroup]="form">
              <select class="form-control" formControlName="companies" (change)="onCompanyChange($event)">
                <option class="form-control" value="" disabled selected hidden>Alegeți o companie</option>
                <option class="form-control" *ngFor="let order of companiesConsumptionPlaces; let i = index"
                  [value]="companiesConsumptionPlaces[i].code">
                  {{companiesConsumptionPlaces[i].name}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="card-body tab2-card">
          <ngb-tabset class="tab-coupon">
            <ngb-tab title="Loc de consum" id="consumption-places">
              <ng-template ngbTabContent>
                <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
                  <div class="form-group row">
                    <div class="col-xl-3 col-md-3">
                      <input class="form-control" type="text" placeholder="POD" [(ngModel)]="podValue" required>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <button type="button" class="btn btn-primary" (click)="associateConsumptionPlace()"
                        [disabled]="!selectedCompany || !isCompanyOwner()">
                        Asociaza loc de consum
                      </button>
                    </div>
                  </div>
                  <br>
                  <div class="category-table custom-datatable" *ngIf='electricityConsumptionPlaces'>
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="consumptionPlaceSettings"
                        [source]="electricityConsumptionPlaces?.content"></ng2-smart-table>
                    </div>
                  </div>
                  <div *ngIf='electricityConsumptionPlaces?.totalElements'>
                    <h4 class="pagination justify-content-center">
                      Total Locuri Consum: {{electricityConsumptionPlaces?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationElectricityConsumptionPlaces" [ngClass]="page.className"
                        (click)="changePage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="card-body tab2-card" *ngIf='!electricityConsumptionPlaces'>
                    <h4> Va rugam selectati o companie sau asociati un loc de consum</h4>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>
            <ngb-tab id="contracts">
              <ng-template ngbTabTitle>Contracte
                <ng-template ngbTabContent>
                  <br>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="contractSettings" [source]="electricityContracts?.content"
                        (custom)="onCustomActionContracts($event)"></ng2-smart-table>
                    </div>
                  </div>
                  <div *ngIf="electricityContracts?.totalElements > 0">
                    <h4 class="pagination justify-content-center">
                      Total contracte: {{electricityContracts?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousContractPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationElectricityContracts" [ngClass]="page.className"
                        (click)="changeContractPage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextContractPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </ng-template>
            </ngb-tab>
            <ngb-tab id="requests">
              <ng-template ngbTabTitle>Cereri
                <ng-template ngbTabContent>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="requestSettings" [source]="electricityRequests?.content"
                        (custom)="onCustomActionRequests($event)"></ng2-smart-table>
                    </div>
                  </div>
                  <div *ngIf="electricityRequests?.totalElements > 0">
                    <h4 class="pagination justify-content-center">
                      Total cereri: {{electricityRequests?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousRequestPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationElectricityRequests" [ngClass]="page.className"
                        (click)="changeRequestPage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextRequestPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </ng-template>
            </ngb-tab>
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
